/**
 * Sums the params
 * @param params
 */
export function sum(params: number[]): number {
  return params.reduce(function (acc, num, i, orig) {
    return acc + num;
  }, 0);
}
